import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import { RouteList } from '../components';
import {
  goUploadPage,
  goUploadHighlightPage,
  goUploadSearchPage,
  goSearchPage,
  goUpalodRiskJudgePage,
  goJudgePage,
  goLoginPage,
} from '../modules/pages';

export function mapDispatchToProps(dispatch: ThunkDispatch<any, any, AnyAction>) {
  return {
    goLoginPage: () => dispatch(goLoginPage()),
    goUploadPage: () => dispatch(goUploadPage()),
    goUploadHighlightPage: () => dispatch(goUploadHighlightPage()),
    goUploadSearchPage: () => dispatch(goUploadSearchPage()),
    goSearchPage: () => dispatch(goSearchPage()),
    goUpalodRiskJudgePage: () => dispatch(goUpalodRiskJudgePage()),
    goJudgePage: () => dispatch(goJudgePage()),
  };
}

export default connect(undefined, mapDispatchToProps)(RouteList);



// WEBPACK FOOTER //
// ./src/containers/RouteList.tsx